import { toDetailItem } from "@/utils/mediaUrl";

const SECTION_ORDER = ["活动通知", "参与名单", "作品案例", "现场照片", "活动总结"];

/**
 * 将 brand-detail API 结果拼成与思想引领页一致的抽屉 payload。
 * @param {object} brandLike { key?, name, status?, participants?, metrics?, content?, summary? }
 * @param {array} sections API sections
 */
export function buildBrandMaterialDrawer(brandLike, sections) {
  const b = brandLike || {};
  const brand = b;
  const metrics = (brand.metrics || [])
    .map(m => `${m.label}：${m.value}`)
    .join(" · ");
  const items = [];

  SECTION_ORDER.forEach(secName => {
    const block = (sections || []).find(s => s.section === secName);
    const rows = (block && block.items) || [];

    if (secName === "现场照片") {
      const thumbs = rows
        .map(r => r.coverUrl || r.CoverUrl)
        .filter(Boolean)
        .map(url => ({ coverUrl: url }));
      if (thumbs.length) {
        items.push(
          toDetailItem({
            title: "",
            category: "现场照片",
            content: "",
            thumbs
          })
        );
      } else {
        items.push(
          toDetailItem({
            title: "",
            category: "现场照片",
            content: "暂无现场照片，请在后台「品牌活动」上传。"
          })
        );
      }
      return;
    }

    if (rows.length) {
      rows.forEach(r => {
        items.push(
          toDetailItem({
            title: "",
            content: r.content || "",
            coverUrl: r.coverUrl,
            category: secName,
            time: r.time
          })
        );
      });
    } else {
      items.push(
        toDetailItem({
          title: "",
          content:
            secName === "活动总结" && (brand.summary || brand.content || b.content)
              ? brand.summary || brand.content || b.content
              : `暂无「${secName}」材料，请在后台「品牌活动」对应字段维护。`,
          category: secName
        })
      );
    }
  });

  const name = brand.name || b.name || "品牌";
  const metricLine =
    metrics || (b.workCount != null ? `作品：${b.workCount || 0}` : null);
  return {
    title: `${name} · 专题材料`,
    summary: [`状态 ${brand.status || b.status || "进行中"}`, metricLine].filter(Boolean),
    items
  };
}

/** 拉取 brand-detail 并生成抽屉 payload */
export async function fetchBrandMaterialDrawer(api, brandLike, branchQuery) {
  const b = brandLike || {};
  let brand = b;
  let sections = [];
  try {
    const res = await api("screen", "brandDetail", {
      key: b.key,
      name: b.name,
      ...(branchQuery || {})
    });
    if (res && res.code === 0) {
      brand = { ...b, ...(res.brand || {}) };
      sections = res.sections || [];
    }
  } catch (e) {
    sections = [];
  }
  return buildBrandMaterialDrawer(brand, sections);
}
